import api from "../index";

export const ParentDetails = () => api.get(`ibusermaster/parent-user-detail`);